import { ORDER_STATUS_ENUM } from '~/enums/Orders.enum';

export const ORDER_PRODUCT_TYPE = {
  ALL: 'ORDERS.PRODUCT_TYPE.ALL',
  HARDWARE: 'ORDERS.PRODUCT_TYPE.HARDWARE',
  SOFTWARE_AND_SERVICE: 'ORDERS.PRODUCT_TYPE.SOFTWARE_AND_SERVICE',
  CLOUD_SERVICE: 'ORDERS.PRODUCT_TYPE.CLOUD_SERVICE',
};
export const ORDER_STATUS = {
  ALL: 'ORDERS.STATUS.ALL',
  [ORDER_STATUS_ENUM.PROCESSING]: 'ORDERS.STATUS.PROCESSING',
  [ORDER_STATUS_ENUM.PROCESSED]: 'ORDERS.STATUS.PROCESSED',
  [ORDER_STATUS_ENUM.INVOICED]: 'ORDERS.STATUS.INVOICED',
  [ORDER_STATUS_ENUM.PARTIALLY_INVOICED]: 'ORDERS.STATUS.PARTIALLY_INVOICED',
  [ORDER_STATUS_ENUM.SHIPPED]: 'ORDERS.STATUS.SHIPPED',
  [ORDER_STATUS_ENUM.PARTIALLY_SHIPPED]: 'ORDERS.STATUS.PARTIALLY_SHIPPED',
  [ORDER_STATUS_ENUM.CANCELED]: 'ORDERS.STATUS.CANCELED',
  [ORDER_STATUS_ENUM.PARTIALLY_CANCELED]: 'ORDERS.STATUS.PARTIALLY_CANCELED',
  [ORDER_STATUS_ENUM.DELAYED]: 'ORDERS.STATUS.DELAYED',
  [ORDER_STATUS_ENUM.PARTIALLY_DELAYED]: 'ORDERS.STATUS.PARTIALLY_DELAYED',
  [ORDER_STATUS_ENUM.PAID]: 'ORDERS.STATUS.PAID',
  [ORDER_STATUS_ENUM.PARTIALLY_PAID]: 'ORDERS.STATUS.PARTIALLY_PAID',
  [ORDER_STATUS_ENUM.TRANSFERRED]: 'ORDERS.STATUS.TRANSFERRED',
};

export const ENUM_ORDER_STATUS = {
  ALL: 'ORDERS.STATUS.ALL',
  PROCESSING: 'ORDERS.STATUS.PROCESSING',
  PROCESSED: 'ORDERS.STATUS.PROCESSED',
  INVOICED: 'ORDERS.STATUS.INVOICED',
  PARTIALLY_INVOICED: 'ORDERS.STATUS.PARTIALLY_INVOICED',
  SHIPPED: 'ORDERS.STATUS.SHIPPED',
  PARTIALLY_SHIPPED: 'ORDERS.STATUS.PARTIALLY_SHIPPED',
  CANCELED: 'ORDERS.STATUS.CANCELED',
  PARTIALLY_CANCELED: 'ORDERS.STATUS.PARTIALLY_CANCELED',
  DELAYED: 'ORDERS.STATUS.DELAYED',
  PARTIALLY_DELAYED: 'ORDERS.STATUS.PARTIALLY_DELAYED',
  PAID: 'ORDERS.STATUS.PAID',
  PARTIALLY_PAID: 'ORDERS.STATUS.PARTIALLY_PAID',
  TRANSFERRED: 'ORDERS.STATUS.TRANSFERRED',
};

export const ORDER_STATUS_TOOLTIP = {
  PROCESSING: 'ORDERS.DETAILS.STATUS.PROCESSING',
  PROCESSED: 'ORDERS.DETAILS.STATUS.PROCESSED',
  INVOICED: 'ORDERS.DETAILS.STATUS.INVOICED',
  PARTIALLY_INVOICED: 'ORDERS.DETAILS.STATUS.PARTIALLY_INVOICED',
  SHIPPED: 'ORDERS.DETAILS.STATUS.SHIPPED',
  PARTIALLY_SHIPPED: 'ORDERS.DETAILS.STATUS.PARTIALLY_SHIPPED',
  CANCELED: 'ORDERS.DETAILS.STATUS.CANCELED',
  PARTIALLY_CANCELED: 'ORDERS.DETAILS.STATUS.PARTIALLY_CANCELED',
  PAID: 'ORDERS.DETAILS.STATUS.PAID',
  PARTIALLY_PAID: 'ORDERS.DETAILS.STATUS.PARTIALLY_PAID',
  TRANSFERRED: 'ORDERS.DETAILS.STATUS.TRANSFERRED',
};

export const ORDER_STATUS_COLORS = {
  [ORDER_STATUS_ENUM.PROCESSING]: 'success',
  [ORDER_STATUS_ENUM.PROCESSED]: 'success',
  [ORDER_STATUS_ENUM.INVOICED]: 'success',
  [ORDER_STATUS_ENUM.PARTIALLY_INVOICED]: 'warn',
  [ORDER_STATUS_ENUM.SHIPPED]: 'success',
  [ORDER_STATUS_ENUM.PARTIALLY_SHIPPED]: 'warn',
  [ORDER_STATUS_ENUM.CANCELED]: 'danger',
  [ORDER_STATUS_ENUM.PARTIALLY_CANCELED]: 'danger',
  [ORDER_STATUS_ENUM.DELAYED]: 'success',
  [ORDER_STATUS_ENUM.PARTIALLY_DELAYED]: 'warn',
  [ORDER_STATUS_ENUM.PAID]: 'success',
  [ORDER_STATUS_ENUM.PARTIALLY_PAID]: 'warn',
  [ORDER_STATUS_ENUM.TRANSFERRED]: 'warn',
};

export const ORDER_LIST_FILTERS = {
  filteredField: '',
  genericTerm: '',
  date: [],
  orderStatus: '',
  productType: '',
};

export const ORDER_LIST_FILTER_OPTIONS = {
  ORDER_NUMBER: 'ORDERS.FILTER_OPTIONS.ORDER_NUMBER',
  FINAL_CUSTOMER_DOCUMENT: 'ORDERS.FILTER_OPTIONS.FINAL_CUSTOMER_DOCUMENT',
  FINAL_CUSTOMER_NAME: 'ORDERS.FILTER_OPTIONS.FINAL_CUSTOMER_NAME',
};
